import React from "react";

const MyToolbarRight = ({ children }) => {
  return <div>{children}</div>;
};

export default MyToolbarRight;
